// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d2-4";
export var closeButton = "_d2-6";
export var dismissButton = "_d2-3";
export var editImageWithAiContainer = "_d2-8";
export var imageUploadWrapper = "_d2-7";
export var misspelledWord = "_d2-5";
export var spellCheckContainer = "_d2-2";
export var spin = "_d2-1";
export var spinning = "_d2-0";